import React from 'react';

import { TabEmptyState } from './TabEmptyState';

export const PatientAppointmentsTab: React.FC = () => {
  return (
    <TabEmptyState
      title="Appointments"
      description="The patient's appointment history will live here."
    />
  );
};
